import Unexpected from '../../Exception/Unexpected.class'
import findByIdOrThrow from '../findByIdOrThrow'
import type { HasEntityTypeId } from './EntityTypeId.enum'
import entityTypeMetaList from './entityTypeMetaList.generated'

export default function entityDisplayName(entity: HasEntityTypeId): string {
  const entityTypeMeta = findByIdOrThrow(entityTypeMetaList, entity.etype_id)
  const dname = entityTypeMeta.dname
  if (!dname) {
    throw new Unexpected('!etm.dname')
  }
  return dname
}
